import React from 'react';
import { observer } from 'mobx-react';
import { useAssessmentDetail } from './useAssessmentDetail';

// Renders its children only once the assessment's full record is in the store.
// The completers seed their editors from the feedback text at mount, so they
// must not mount against the trimmed list row.
const AssessmentDetailGate = ({ assessment, children }) => {
    const { pending, failed, retry } = useAssessmentDetail(assessment);

    if (pending) {
        return <div data-testid="assessment-detail-loading" style={{ marginTop: 20 }}>Loading feedback...</div>;
    }

    if (failed) {
        return (
            <div data-testid="assessment-detail-error" style={{ marginTop: 20 }}>
                Couldn't load this feedback.{' '}
                <button type="button" onClick={retry}>Retry</button>
            </div>
        );
    }

    return children;
};

export default observer(AssessmentDetailGate);
